import { supabase } from '../config/supabase';

// Convert camelCase to snake_case for database
const toSnakeCase = (data) => {
  return {
    award_number: data.awardNumber,
    termination_notice: data.terminationNotice,
    contact_email: data.contactEmail,
    qualitative_response: data.qualitativeResponse,
    risk_assessment: data.riskAssessment,
  };
};

// Convert snake_case back to camelCase for frontend
const toCamelCase = (data) => {
  if (!data) return null;
  return {
    awardNumber: data.award_number,
    terminationNotice: data.termination_notice,
    contactEmail: data.contact_email,
    qualitativeResponse: data.qualitative_response,
    riskAssessment: data.risk_assessment,
    createdAt: data.created_at,
  };
};

export const submitTerminationInfo = async (terminationData) => {
  try {
    const { data, error } = await supabase
      .from('nih_terminations')
      .insert([toSnakeCase(terminationData)]);
    
    if (error) {
      throw error;
    }
    
    return { success: true, data: data ? toCamelCase(data[0]) : null };
  } catch (error) {
    console.error('Error submitting termination information:', error);
    return { success: false, error: error.message };
  }
};

export const getTerminationStats = async () => {
  try {
    // Query the stats view we created in the SQL setup
    const { data: statsData, error: statsError } = await supabase
      .from('nih_termination_stats')
      .select('*')
      .single();
    
    if (statsError) {
      throw statsError;
    }
    
    // Get risk assessment distribution using our SQL function
    const { data: riskData, error: riskError } = await supabase
      .rpc('get_risk_assessment_distribution');
    
    if (riskError) {
      throw riskError;
    }
    
    return { 
      success: true, 
      stats: statsData,
      riskDistribution: riskData
    };
  } catch (error) {
    console.error('Error fetching termination stats:', error);
    return { success: false, error: error.message };
  }
};

// Function to get recent submissions (with sensitive info removed)
export const getRecentSubmissions = async (limit = 5) => {
  try {
    const { data, error } = await supabase
      .from('nih_terminations')
      .select('id, award_number, qualitative_response, risk_assessment, created_at')
      .order('created_at', { ascending: false })
      .limit(limit);
    
    if (error) {
      throw error;
    }
    
    return { 
      success: true, 
      submissions: data ? data.map(toCamelCase) : [] 
    };
  } catch (error) {
    console.error('Error fetching recent submissions:', error);
    return { success: false, error: error.message };
  }
};

export const submitContactMessage = async (contactData) => {
  try {
    const { data, error } = await supabase
      .from('contact_messages')
      .insert([{
        name: contactData.name,
        email: contactData.email,
        subject: contactData.subject,
        message: contactData.message
      }]);
    
    if (error) {
      throw error;
    }
    
    return { success: true, data };
  } catch (error) {
    console.error('Error submitting contact message:', error);
    return { success: false, error: error.message };
  }
};